var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXCircle = function SvgXCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.988c5.53 0 10.012 4.483 10.012 10.012S17.529 22.012 12 22.012 1.99 17.529 1.988 12C1.988 6.47 6.471 1.989 12 1.988m0 1.2a8.813 8.813 0 0 0 0 17.624 8.812 8.812 0 0 0 0-17.624m2.47 5.634a.5.5 0 0 1 .708.707L12.708 12l2.47 2.47a.5.5 0 0 1-.707.708L12 12.707l-2.47 2.47a.5.5 0 0 1-.708-.707l2.47-2.471-2.47-2.47a.5.5 0 1 1 .707-.707l2.47 2.47z"
  })));
};
export default SvgXCircle;